import config from "../config";
var axios = config();

export default {
  getSitesWithNoOpportunity() {
    return axios.get("/api/StudentOpportunities/GetSitesWithNoOpportunity", {});
  },
  getSite(id) {
    return axios.get("/api/StudentOpportunities/GetSiteById", {
      params: { id: id }
    });
  },
  getSiteSupervisors(siteId) {
    return axios.get("/api/Sites/GetSiteSupervisors", {
      params: { siteId: siteId }
    });
  },
  getSiteSupervisorsByStudentOpportunity(studentOpportunityId) {
    return axios.get("/api/Sites/getSiteSupervisorsByStudentOpportunity", {
      params: { studentOpportunityId: studentOpportunityId }
    });
  }
};
